// Update member price when variant changes
document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  if (!variant) return;

  const memberPriceContainer = document.querySelector('[data-member-price]');
  const memberPriceEl = memberPriceContainer ? memberPriceContainer.querySelector('span') : null;
  if (!memberPriceEl) return;

  // Read member multiplier from Liquid template (fallback to 0.75 = 25% off)
  const memberMultiplier = parseFloat(memberPriceContainer.getAttribute('data-member-multiplier')) || 0.75;
  const memberPrice = variant.price * memberMultiplier;
  
  // Format the price using Shopify's money format
  memberPriceEl.innerHTML = theme.Currency.formatMoney(memberPrice, theme.moneyFormat);
});
